// This file exists separately to prevent circular imports between modal registration
// and dialog actions that might also reference those types/components.

export const MODAL_COMPONENTS = {};

// New way of registering modal components. Registering makes the modal available at the root level.
// This method accepts a lamda to dyamically import the component. The main reason to use this over
// RegisterModalComponent is to support hot reloading during development.
//
export const ImportModalComponent = (key, getComponent) => {
  Object.defineProperty(MODAL_COMPONENTS, key, {
    configurable: true,
    get: async () => {
      const component = await getComponent();
      return component.default || component;
    },
  });
};

// Registering a modal component adds it to the list of modals available at the root level. Consider
// using ImportModalComponent instead, in addition to adding it to list of available modals, it
// supports hot reloading in development.
//
export const RegisterModalComponent = (key, component) => {
  MODAL_COMPONENTS[key] = component;
};
